import { UserTockem } from "../../Utils/autenticacao";
import axios from "axios";
import { urlBase } from "../../Constante/Url";

function getConfig(params) {
  return {
    headers: { Authorization: `Bearer ${localStorage.getItem(UserTockem)}` },
    params: params,
  };
}

const getGeoLoc = () => {
  const response = axios.get(
    `${urlBase}cartorio/buscar-cartorio-geolocalizacao/`,
    getConfig()
  );
  return response;
};

export const MapRequest = {
  getGeoLoc,
};
